import React from "react";
import { Link } from 'react-router';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import LoginStore from "../../stores/login-store";
import PageHeader from "../../components/banners/page-header";
import StartTrialBanner from "../../components/banners/start-trial";
import Faqs from "./contact-faqs";
import "./contact.scss";

export default class FaqsPage extends React.Component {
  render() {
    const trialBanner = LoginStore.isLoggedIn() ? null : (
      <StartTrialBanner {...this.props} />
    );

    return (
      <div>
        <SEOHead {...SEO_CONFIG.faqs} />
        <PageHeader eyebrow="FAQs" title={<React.Fragment>Frequently asked <em>questions</em></React.Fragment>}>
          <p>Can't find what you're looking for? <Link to="/contact">Contact us</Link> and we'll help.</p>
        </PageHeader>

        <div id="faqs" className="faqs-page">
          <Faqs />
        </div>

        {trialBanner}
      </div>
    );
  }
}
